class HeroVideoDeferred extends HTMLElement {
  #loaded = false;
  #fallbackTimer;

  connectedCallback() {
    this.video = this.querySelector('video');
    this.sources = [...this.querySelectorAll('source[data-video-source]')];

    if (!this.video || this.sources.length === 0) return;

    if (!window.matchMedia('(max-width: 749px)').matches) {
      this.#loadVideo();
      return;
    }

    window.addEventListener('pointerdown', this.#loadVideo, { once: true });
    window.addEventListener('touchstart', this.#loadVideo, { passive: true, once: true });
    window.addEventListener('wheel', this.#loadVideo, { passive: true, once: true });
    window.addEventListener('keydown', this.#loadVideo, { once: true });
    this.#fallbackTimer = window.setTimeout(this.#scheduleIdleLoad, 30000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#fallbackTimer);
    this.#removeInteractionListeners();
  }

  #scheduleIdleLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(this.#loadVideo, { timeout: 2000 });
    } else {
      this.#loadVideo();
    }
  };

  #loadVideo = () => {
    if (this.#loaded) return;
    this.#loaded = true;

    for (const source of this.sources) {
      const sourceUrl = source.dataset.videoSource;
      if (sourceUrl) source.src = sourceUrl;
    }

    this.video.load();
    this.video.play().catch(() => {});
    window.clearTimeout(this.#fallbackTimer);
    this.#removeInteractionListeners();
  };

  #removeInteractionListeners() {
    window.removeEventListener('pointerdown', this.#loadVideo);
    window.removeEventListener('touchstart', this.#loadVideo);
    window.removeEventListener('wheel', this.#loadVideo);
    window.removeEventListener('keydown', this.#loadVideo);
  }
}

if (!customElements.get('hero-video-deferred')) {
  customElements.define('hero-video-deferred', HeroVideoDeferred);
}
